export default __webpack_public_path__ + "static/media/iconCardEmployees.6d07efff.svg";